// @flow

import * as React from 'react'
import { connect } from 'react-redux'
import { Modal } from 'semantic-ui-react'
import { silver, prussian } from 'constants/inlineStyles'

import { closeModal } from '../../../redux'

let styles = {}

type ReduxDispatchProps = {|
  +onCloseModal: () => void
|}

type OwnProps = {|
  children: React.Node,
  header?: React.Node,
  style: Object // FIXME
  // header styles
  // styles in general (border of modal, etc)
  // optional style object for modal content? default flex column or something
  // children in Modal.Conent
|}

type Props = {|
  ...ReduxDispatchProps,
  ...OwnProps
|}

const ModalContainer = ({ children, onCloseModal, header, style }: Props) => (
  <Modal
    style={{ ...styles.largeSilverBorder, ...style }}
    className="Share-Modal"
    // dimmer="blurring"
    size="tiny"
    role="dialog"
    open
    onClose={onCloseModal}
    closeIcon={{
      name: 'close',
      ariaLabel: 'close',
      as: 'span',
      className: 'pj-close',
      color: 'black',
      style: {
        cursor: 'pointer'
      }
    }}
  >
    <Modal.Header style={styles.header}>{header}</Modal.Header>
    {children}
  </Modal>
)

const mapDispatchToProps = (dispatch): ReduxDispatchProps => ({
  onCloseModal: () => dispatch(closeModal())
})

styles = {
  largeSilverBorder: { border: `4px solid ${silver}` },
  header: {
    color: `${prussian}`,
    fontSize: '28px',
    fontWeight: 'bold',
    lineHeight: '28px',
    textAlign: 'center'
  }
}

export default connect(null, mapDispatchToProps)(ModalContainer)



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/ModalManager/components/ModalContainer.js